<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div
          class="col-9 bgazuladmin bgazulgradiente p-5"
          v-if="userProfile != null"
        >
          <div class="row p-5" data-aos="fade-left" data-aos-delay="200">
            <div class="col-12 pb-5">
              <h2 class="blanco bold pb-3">Estudiantes</h2>
              <div class="row">
                <div class="col-12">
                  <download-excel
                    :data="this.estudiantes"
                    name="Resultados Individuales Estudiantes"
                  >
                    <button class="btn btn-danger">
                      Exportar Resultados Individuales
                    </button>
                  </download-excel>
                </div>
                <div class="col-12 admintabla">
                  <v-client-table
                    :columns="columns"
                    v-model="estudiantes"
                    :options="options"
                  >
                    <div
                      slot="resultado"
                      slot-scope="props"
                      @click="
                        resultados(
                          props.row.user_id,
                          props.row.nombre,
                          props.row.apellidos
                        )
                      "
                      class="glyphicon glyphicon-eye-open fpG blanco pointer"
                      v-if="props.row.mostrar_descarga === true"
                    >
                      &nbsp; Descargar
                    </div>

                    <div
                      slot="name"
                      slot-scope="{
                        row,
                        update,
                        setEditing,
                        isEditing,
                        revertValue,
                      }"
                    >
                      <span @click="setEditing(true)" v-if="!isEditing()">
                        <a>{{ row.name }}</a>
                      </span>
                      <span v-else>
                        <input type="text" v-model="row.name" />
                        <button
                          type="button"
                          class="btn btn-info btn-xs"
                          @click="
                            update(row.name);
                            setEditing(false);
                          "
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-default btn-xs"
                          @click="
                            revertValue();
                            setEditing(false);
                          "
                        >
                          Cancel
                        </button>
                      </span>
                    </div>
                  </v-client-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import {
  misionesCollection,
  usersCollection,
  membresiasCollection,
} from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
  },
  data() {
    return {
      file: null,
      csv: null,
      formDisponibles: {
        disponibles: 100,
      },
      form: {
        id_usuario: "",
        nombre: "",
        apellidos: "",
        email: "",
        plantel: "",
        grupo: "",
      },
      formCargar: {
        file: "",
      },
      formFacturacion: {
        rfc: "",
        nombre: "",
        email: "",
        telefono: "",
        direccion: "",
      },
      columns: [
        "resultado",
        "id",
        "user_id",
        "registrado",
        "nivel",
        "pdf",
        "nombre",
        "apellidos",
        "email",
        "plantel",
        "grupo",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          resultado: "Acción",
          id: "ID Membresía",
          user_id: "ID Usuario",
          registrado: "Registrado",
          nivel: "Avance",
          pdf: "Resultado PDF",
          nombre: "Nombre",
          apellidos: "Apellidos",
          email: "Email",
          plantel: "Plantel",
          grupo: "Grupo",
        },
        editableColumns: [],
        sortable: [],
        texts: {
          count:
            "Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro",
          first: "Primero",
          last: "Último",
          filter: "Filtro:",
          filterPlaceholder: "Búsqueda",
          limit: "Registros:",
          page: "Página:",
          noResults: "No hay datos.",
          noRequest: "Por favor selecciona una opción para filtrar resultados",
          filterBy: "Filtrar por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      grupos: [],
      planteles: [],
      estudiantes: [],
      estudiantesObj: [],
      estilo_de_aprendizaje: {},
      estilo_de_pensamiento: {},
      perfil_de_competencias: [],
      aprendizaje_usuario: "",
      fortaleza_usuario: "",
      debilidad_usuario: "",
      camposObj: null,
      campos_aptos: [],
      campos_especificos_usuario: [],
      campos_especificos: [],
      bases: null,
      base_seleccionada: null,
      base_seleccionada_obj: null,
      frase_nivel_5: null,
      avance: null,
      initiated: false,
    };
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
    institucionID(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  mounted: async function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();
  },
  methods: {
    async init() {
      if (
        this.userProfile == null ||
        this.institucionID == null ||
        this.initiated == true
      ) {
        return;
      }

      console.log("iniciando resultados individuales");

      this.initiated = true;

      //////////////////////////

      this.camposObj = this.$store.state.campos_conocimiento;
      this.planteles = this.$store.state.admin.planteles;
      this.grupos = this.$store.state.admin.grupos;
      //this.estudiantes = this.$store.state.admin.estudiantes;

      await this.getMisiones();
      await this.getEstudiantes();

      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
        disponibles: this.userProfile.disponibles,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }

      console.log({ datosInstitucion: institucion });
      console.log({ institucionID: this.institucionID });

      //PDF resultados
      this.estilo_de_aprendizaje = this.$store.state.estilo_de_aprendizaje;
      this.estilo_de_pensamiento = this.$store.state.estilo_de_pensamiento;
      this.perfil_de_competencias = this.$store.state.perfil_de_competencias;
      this.camposObj = this.$store.state.campos_conocimiento;
      this.campos_especificos = this.$store.state.campos_especificos;
      this.bases = this.$store.state.bases;
    },
    async getMision(user_id) {
      let misiones = await misionesCollection.doc(user_id).get();

      misiones = null;
      if (misiones.exist === true) {
        try {
          //
        } catch (e) {
          //
        }
      }

      console.log({ getMision: misiones });
    },
    async getMisiones() {

      console.log('getting misiones');

      this.$store.dispatch("showLoader", true);

      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }

      console.log({institucion})
      console.log({userprofile: this.userProfile.user_level})
      console.log({userprofilegrupo: this.userProfile.grupo})

      let docs;
      if (this.userProfile != null && this.userProfile.user_level == 5) {
        docs = await misionesCollection
          .where("institucion_id", "==", institucion.institucion_id)
          // .where("plantel", "==", this.userProfile.plantel)
          .where("user.membresia.grupo", "==", this.userProfile.grupo)
          .get();
      } else {
        docs = await misionesCollection
          .where("institucion_id", "==", institucion.institucion_id)
          // .where("plantel", "==", this.userProfile.plantel)
          // .where("grupo", "==", this.userProfile.grupo)
          .get();
      }

      console.log({docs})
      
      this.misiones = [];
      let thes = this;
      docs.forEach(async (doc) => {
        let mision = doc.data();

        console.log({ estuUserIDdetalle: doc.id });
        mision.id = doc.id;
        thes.misiones[doc.id] = mision;

        console.log({ estudianteResultado: thes.estudiantesObj });
      });

      console.log({ misiones: this.misiones });

      this.$store.dispatch("showLoader", false);

      //this.setResumen();
    },
    async getEstudiantes() {
      this.$store.dispatch("showLoader", true);

      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }

      let docs;
      if (this.userProfile != null && this.userProfile.user_level == 5) {
        //console.log('entro')
        if(Array.isArray(this.userProfile.grupo)){
          console.log({'es array': this.userProfile.grupo})
          docs = await membresiasCollection
          .where("institucion_id", "==", institucion.institucion_id)
          .where("plantel", "==", this.userProfile.plantel)
          .where("grupo", "in", this.userProfile.grupo)
          .get();
        }else{
          docs = await membresiasCollection
          .where("institucion_id", "==", institucion.institucion_id)
          .where("plantel", "==", this.userProfile.plantel)
          .where("grupo", "==", this.userProfile.grupo)
          .get();
        }
      } else {
        docs = await membresiasCollection
          .where("institucion_id", "==", institucion.institucion_id)
          .get();
      }

      this.estudiantes = [];
      let thes = this;
      docs.forEach(async (doc) => {
        let estudiante = doc.data();

        console.log({ estuUserID: estudiante.user_id });

        if (estudiante.user_id != undefined) {
          estudiante.registrado = "Registrado";
        }

        estudiante.nivel = "";
        estudiante.no_nivel = "";

        try {
          estudiante.no_nivel = this.misiones[estudiante.user_id].nivel;
          estudiante.nivel = "Nivel " + this.misiones[estudiante.user_id].nivel;
        } catch (e) {
          //
        }

        estudiante.mostrar_descarga = false;
        estudiante.pdf = "";
        try {
          if (estudiante.no_nivel >= 1) {
            estudiante.mostrar_descarga = true;
            estudiante.pdf = "Disponible";
          }
        } catch (e) {
          //
        }

        thes.estudiantes.push(estudiante);
        estudiante.id = doc.id;

        //console.log({ estudianteResultado: thes.estudiantesObj });
      });
      this.estudiantes = this.estudiantes.sort(this.custom_sort);

      //console.log({ estudiantesresultado: this.estudiantes });

      this.$store.dispatch("showLoader", false);

      //this.setResumen();
    },
    custom_sort(a, b) {
      try {
        return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
      } catch (e) {
        return false;
      }
    },
    async confirmarCarga() {
      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }
      console.log({ institucionconfirmar: institucion });

      this.csv.forEach(async (estudiante) => {
        if (estudiante.email != null && estudiante.email != "") {
          console.log({ estudiante: estudiante });
          // let res = await this.$store.dispatch("creaMembresiaInstitucion", {
          //   estudiante: estudiante,
          //   institucion: institucion,
          // });

          // if(res === true){
          //   this.estudiantes.push(estudiante);
          // }
        }
      });
      this.csv = null;
      this.$store.state.admin.estudiantes = this.estudiantes;
    },
    submitCarga() {
      console.log({ csv: this.csv });
    },
    fileSelected: function ($event) {
      console.log($event);

      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.

        console.log(e.target.result);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    submitForm(e) {
      e.preventDefault();

      this.estudiantes.push(this.form);
      this.$store.state.admin.estudiantes = this.estudiantes;

      //this.$store.dispatch("setDatosAdministrador", this.form);
    },
    //PDF
    async resultados(user_id, nombre, apellidos) {
      if (user_id == null || user_id == undefined || user_id == "") {
        swal.fire(
          "Oops",
          "Este estudiante aún no ha comenzado con las misiones.",
          "warning"
        );
        return;
      }

      console.log(user_id);

      this.avance = await this.$store.dispatch("getAvance", user_id);
      console.log({ avance: this.avance });

      //nivel 1
      try {
        this.aprendizaje_usuario = this.avance.misiones[0].resultado_evaluacion;
      } catch (e) {
        this.aprendizaje_usuario = "";
      }
      //nivel 2
      try {
        this.resultado_nivel_2 = this.avance.misiones[1];
      } catch (e) {
        this.resultado_nivel_2 = "";
      }

      try {
        this.fortaleza_usuario = this.resultado_nivel_2.fortaleza;
        this.getDebilidad();
      } catch (e) {
        this.fortaleza_usuario = "";
        console.log({ debilidad: this.debilidad_usuario });
      }

      try {
        this.perfil_de_competencias_usuario =
        this.resultado_nivel_2.competencias;
      } catch (e) {
        this.perfil_de_competencias_usuario = {};
      }

      //nivel 3
      try {
        this.campos_aptos = this.avance.misiones[2].campos_aptos;
        this.initCampos();
      } catch (e) {
        //this.campos_aptos = [];
        console.log({ campos_aptos: this.campos_aptos });
      }

      //retención de prueba a nivel 3
      // // // if (this.campos_aptos.length == 0) {
      // // //   swal.fire(
      // // //     "Oops",
      // // //     nombre +
      // // //       " ya comenzó su prueba pero aún no ha completado el mínimo avance requerido para producir resultados, al menos debe de completar el planeta 3."
      // // //   );
      // // //   return;
      // // // }

      if (this.campos_aptos.length > 0) {
        try {
          if (this.avance.misiones[3].base_seleccionada != null) {
            this.base_seleccionada = this.avance.misiones[3].base_seleccionada;
            this.base_seleccionada_obj =
              this.bases["base_" + this.avance.misiones[3].base_seleccionada];
          }
        } catch (e) {
          this.base_seleccionada_obj = [];
        }
      }

      this.generaPDF(nombre + " " + apellidos);
    },
    getDebilidad() {
      switch (this.fortaleza_usuario) {
        case "habilidad_0":
          this.debilidad_usuario = "habilidad_3";
          break;
        case "habilidad_1":
          this.debilidad_usuario = "habilidad_2";
          break;
        case "habilidad_2":
          this.debilidad_usuario = "habilidad_1";
          break;
        case "habilidad_3":
          this.debilidad_usuario = "habilidad_0";
          break;
      }
    },
    initCampos() {
      let thes = this;
      this.campos_aptos.forEach((element) => {
        thes.camposObj["obj" + element.campo].display = true;
        let campo_especifico =
          thes.campos_especificos["obj" + element.campo_especifico];
        if (
          !thes.camposObj[
            "obj" + element.campo
          ].campos_especificos_usuario.includes(campo_especifico)
        ) {
          thes.camposObj["obj" + element.campo].campos_especificos_usuario.push(
            campo_especifico
          );
        }
      });
      console.log({ camposObj: this.camposObj });
    },
    getCamposUsuario() {
      let thes = this;
      let temp = [];
      for (var i = 1; i < 11; i++) {
        if (thes.camposObj["obj" + i].display === true) {
          temp.push(thes.camposObj["obj" + i]);
        }
      }
      return temp;
    },
    getFrase(nombre) {
      try {
        let frase = null;

        if (this.avance.misiones[4].res1 != null) {
          frase =
            this.bases["base_" + this.base_seleccionada].enunciados[0] +
            " " +
            nombre +
            " " +
            this.avance.misiones[4].res1.toLowerCase() +
            " al objetivo " +
            this.avance.misiones[4].res2.toLowerCase() +
            " " +
            this.avance.misiones[4].res3.toLowerCase() +
            ", enfocándose en " +
            this.avance.misiones[4].res4.toLowerCase() +
            ".";
        }

        return frase;
      } catch (e) {
        return "";
      }
    },
    objectSize(obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) size++;
      }
      return size;
    },
    generaPDF(nombre) {
      this.$store.dispatch("showLoader", true);

      //generar data

      let perfil_competencias_pdf = {};
      this.perfil_de_competencias.forEach((perfil) => {
        // console.log({ perfil: perfil });
        // console.log({
        //   usuarilength: this.objectSize(this.perfil_de_competencias_usuario)
        // });
        if (
          perfil.habilidades_necesarias.length ==
          this.objectSize(this.perfil_de_competencias_usuario)
        ) {
          //continuar busqueda
          let concordancia = true;
          for (var i = 0; i < 4; i++) {
            //console.log({ habilidad: this.perfil_de_competencias_usuario[i] });
            if (this.perfil_de_competencias_usuario[i] != null) {
              if (
                !perfil.habilidades_necesarias.includes(
                  this.perfil_de_competencias_usuario[i][0]
                )
              ) {
                concordancia = false;
              }
            }
          }

          if (concordancia === true) {
            perfil_competencias_pdf = perfil;
          }
        }
      });

      //get campos
      let campos_usuario = this.getCamposUsuario();

      //get frase nivel 5
      this.frase_nivel_5 = this.getFrase(nombre);

      //llamado api

      const https = require("https");

      var qData = {
        estilo_de_aprendizaje:
          this.estilo_de_aprendizaje[this.aprendizaje_usuario],
        fortaleza: this.estilo_de_pensamiento[this.fortaleza_usuario],
        debilidad: this.estilo_de_pensamiento[this.debilidad_usuario],
        perfil_de_competencias: perfil_competencias_pdf,
        nombre_usuario: nombre,
        campos_especificos: campos_usuario,
        base_seleccionada_obj: this.base_seleccionada_obj,
        frase_nivel_5: this.frase_nivel_5,
      };

      console.log({ getPDF: qData });

      this.$http
        .post(
          "https://reporteriapdfprod.com/api/resultados/pdf-resultado.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res pdf");
            console.log(response);

            //window.open("data:application/pdf," + response.body);

            // let pdfWindow = window.open("");
            // pdfWindow.document.write(
            //   "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            //     response.bodyText +
            //     "'></iframe>"
            // );

            var byteCharacters = response.bodyText;
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);
            //window.open(fileURL, "Encauce - Tus Resultados");

            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.download = "Encauce - Resultados de " + nombre;
            fileLink.click();
            // let pdfWindow = window.open("", 'Encauce - Tus Resultados');

            // pdfWindow.document.write(
            //   "<iframe width='100%' height='100%' src='" +
            //     fileURL +
            //     "'></iframe>"
            // );
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>
